var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneralIconsBarCode({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 15.75,
    viewBox: "0 0 21 15.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,0H.738V-15.75H0ZM1.1-.011h.375V-15.75H1.1Zm1.113,0h.363V-15.75H2.215Zm1.84,0h.363V-15.75H4.055Zm1.477,0h.727V-15.75H5.531Zm1.84,0h.363V-15.75H7.371Zm.738,0h.363V-15.75H8.109Zm.738,0h.363V-15.75H8.848Zm1.465,0h.738V-15.75h-.738Zm1.84,0h.738V-15.75h-.738Zm1.477,0h.738V-15.75h-.738Zm1.477,0h.738V-15.75h-.738Zm1.1,0h.738V-15.75h-.738Zm1.852,0h1.1V-15.75h-1.1Zm1.465,0H19.9V-15.75h-.375ZM20.262,0H21V-15.75h-.738Z",
    transform: "translate(0 15.75)",
    fill: "#888075"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralIconsBarCode);
export default __webpack_public_path__ + "static/media/generalIcons_BarCode.ab848e0f228836450aa15114a5933d43.svg";
export { ForwardRef as ReactComponent };